import { ButtonParticipant } from '@/components/ButtonParticipant'

interface ButtonParticipantVideoProps {
  isVideoButtonVisible: boolean
  isVideoEnabled: boolean
  onToggleVideo: () => void
  participantName: string
  videoMuted: boolean
}

export const ButtonParticipantVideo = ({
  isVideoButtonVisible,
  isVideoEnabled,
  onToggleVideo,
  participantName,
  videoMuted,
}: ButtonParticipantVideoProps) => {
  return (
    <ButtonParticipant
      isActive={!videoMuted}
      disabled={!isVideoEnabled}
      isVisible={isVideoButtonVisible}
      onClick={onToggleVideo}
      tag={videoMuted ? 'videocam-off' : 'videocam'}
    >
      <span className="sr-only">
        {videoMuted ? 'Unmute' : 'Mute'} Video for {participantName}
      </span>
    </ButtonParticipant>
  )
}
